import React       from 'react';
import CustomQuote from 'pu-react/components/CustomQuote';

const Component = () => (
  <CustomQuote>
    <div className="col-md-6">
      <ul className="list-no-padding">
        <li>Via Fill</li>
        <li>Blind / Buried Vias</li>
      </ul>
    </div>
    <div className="col-md-6">
      <ul className="list-no-padding">
        <li>Castellated Holes</li>
        <li>ITAR</li>
      </ul>
    </div>
  </CustomQuote>
);

export default Component;
